export const RENTAL_PORTAL_MOCK_STATE_ENABLED = false

export const RENTAL_PORTAL_MOCK_STATE_PARAM = 'mock_state'

export const RENTAL_PORTAL_MOCK_STATE = {
  allRights: 'all-rights',
  bulk: 'bulk',
  canApprove: 'can-approve',
  canConfigurePolicy: 'can-configure-policy',
  canRevealIdentity: 'can-reveal-identity',
  canViewAudit: 'can-view-audit',
  canViewSensitive: 'can-view-sensitive',
  connectionError: 'connection-error',
  creditCheckError: 'credit-check-error',
  empty: 'empty',
  error: 'error',
  loading: 'loading',
  massActionError: 'mass-error',
  massActionMixed: 'mass-mixed',
  massActionPartial: 'mass-partial',
  matchNoRequestRight: 'match-no-request-right',
  matchNoSuggestions: 'match-no-suggestions',
  matchNotEvaluated: 'match-none',
  matchRequestThrottled: 'match-request-throttled',
  matchStale: 'match-stale',
  matchUnavailable: 'match-unavailable',
  needsReauth: 'needs-reauth',
  noApplicantsAccess: 'no-applicants-access',
  noAttention: 'no-attention',
  noBucketing: 'no-bucketing',
  noCreate: 'no-create',
  noEligibleReviewer: 'no-eligible-reviewer',
  noFourEyes: 'no-four-eyes',
  noHandoff: 'no-handoff',
  noIntegrationsGrant: 'no-integrations-grant',
  noMatchedListing: 'no-matched-listing',
  noMatching: 'no-matching',
  noPhase: 'no-phase',
  noSanctions: 'no-sanctions',
  noScreen: 'no-screen',
  noSelect: 'no-select',
  noStage: 'no-stage',
  noStrip: 'no-strip',
  noStripLabel: 'no-strip-label',
  noTabs: 'no-tabs',
  notConnected: 'not-connected',
  noUnits: 'no-units',
  oneApprover: 'one-approver',
  portalNotEnabled: 'portal-not-enabled',
  readOnly: 'read-only',
  reducedManager: 'reduced-manager',
  refreshError: 'refresh-error',
  saveConflict: 'save-conflict',
  saveError: 'save-error',
  simpleTenant: 'simple-tenant',
  slotTaken: 'slot-taken',
  slowRefresh: 'slow-refresh',
  threePhases: 'three-phases',
}

export const RENTAL_PORTAL_MOCK_STATE_PREFIX = {
  creditCheck: 'credit-check-',
}

export const RENTAL_PORTAL_MOCK_LATENCY = 2500

export const RENTAL_PORTAL_MOCK_NO_CREATE_STATES = [
  RENTAL_PORTAL_MOCK_STATE.noCreate,
  RENTAL_PORTAL_MOCK_STATE.readOnly,
  RENTAL_PORTAL_MOCK_STATE.reducedManager,
]

// TODO: company flags ride a module-level holder until the matching settings
// endpoint exists.
export const RENTAL_PORTAL_MOCK_COMPANY_FLAGS = {
  auto_request_on_intake: false,
  fit_score: true,
  occupancy_norms: false,
}
